import { render, staticRenderFns } from "./mainLanding.vue?vue&type=template&id=2c76c722&"
import script from "./mainLanding.vue?vue&type=script&lang=js&"
export * from "./mainLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports